module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/indoor-climate-controlled-storage-units.webp";